<div class="fx-row-start-center">
  <div>
   <a class="navlink" routerLink="/apps">EOLA : Enterprise View : </a>
  </div>
  <div>
   <a class="navlink" routerLink="/plantView/{{plant}}">{{plant}}</a>
  </div>
  <div>
    <a class="navlink" routerLink="/details/{{plant}}" [queryParams]="{Severity: severity, Line: line}">: {{line}} : {{severityInfo}}</a>
  </div>
</div> 

<mat-tab-group mat-stretch-tabs="false" dynamicHeight>
      <mat-tab label="Pareto">
        <ng-template matTabContent>
              <app-pareto></app-pareto>
        </ng-template>
      </mat-tab>
</mat-tab-group>

